import ProfileIcon from '@/assets/icons/icon-profile.svg';
import { PersonalCabinet, ProfilePopupContent } from '@/components';
import useAuthModal from '@/zustand/useAuthModal';
import useUserStore from '@/zustand/useUser';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useRef, useState } from 'react';
import { FaRegUser } from 'react-icons/fa';
import { Popover, Whisper } from 'rsuite';
import styles from './sign-button.module.scss';

const SignInButton = ({ setOpenModal }: any) => {
  const [openCabinet, setOpenCabinet] = useState(false);
  const { isPopoverOpen, setPopoverOpen } = useAuthModal();
  const triggerRef = useRef<any>();
  const { user } = useUserStore();
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';
  const t = useTranslations('General');

  // const openPopover = () => {
  //   if (triggerRef) {
  //     triggerRef.current.open();
  //   }
  // };

  // const closePopover = () => {
  //   if (triggerRef) {
  //     triggerRef?.current?.close();
  //   }
  // };

  const handleOpen = () => {
    setOpenModal(true);
    setPopoverOpen(false);
  };

  return (
    <div className={styles.stickyHeader}>
      <Whisper
        placement="bottomStart"
        controlId="control-id-click"
        ref={triggerRef}
        trigger="click"
        open={isPopoverOpen}
        onClick={() => setPopoverOpen(true)}
        speaker={
          <Popover className={styles.signInPopover} style={{ zIndex: 3000 }}>
            {!user ? (
              <PersonalCabinet
                handleOpen={handleOpen}
                handleClose={() => setPopoverOpen(false)}
                // handleClose={() => closePopover()}
              />
            ) : (
              <ProfilePopupContent
                setOpenCabinet={setOpenCabinet}
                handleClose={() => setPopoverOpen(false)}
              />
            )}
          </Popover>
        }
      >
        <div className={styles.headerBottomIcon}>
          {user ? (
            <>
              <div className={styles.profilePlaceholderIcon}>
                {user?.avatar?.url ? (
                  <Image
                    src={user?.avatar.url}
                    width={50}
                    height={50}
                    alt="User Avatar"
                    className={styles.leftUserAvatar}
                  />
                ) : (
                  <FaRegUser className={styles.leftUserIcon} />
                )}
                {/* <FaRegUser className={styles.leftUserIcon} /> */}
              </div>
              <p className={styles.profileName}>
                {' '}
                {`${firstName} ${lastName}`.trim() !== ''
                  ? `${firstName} ${lastName}`
                  : `${user?.phone}`}
              </p>
            </>
          ) : (
            <>
              {' '}
              <ProfileIcon /> <p>{t('enter')}</p>{' '}
            </>
          )}
        </div>
      </Whisper>
    </div>
  );
};

export default SignInButton;
